import { useState } from "react";
import ListSuperAdmin from "./ListSuperAdmin";
import { Grid } from "react-feather";
import AddSuperAdmin from "./AddSuperAdmin";
import useAuth from "../../../../hooks/useAuth";
import Page401 from "../../../auth/Page401";
import SuccessMessageComponent from "../../../components/SuccessMessageComponent";

export default function ManageSuperAdmin() {
    const [showAddSuperAdminForm, setShowAddSuperAdminForm] = useState(false);
    const { user } = useAuth();
    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });

    const handleCloseSuccessMessage = () => {
        setOperationStatus({ success: false, failed: false, message: "" });
    };

    if (!user || !user.roleName || (user.roleName && user.roleName.toLowerCase() !== "super_admin")) {
        return <Page401 />;
    }
    return (
        <>
            {showAddSuperAdminForm ? (
                <AddSuperAdmin setShowAddSuperAdminForm={setShowAddSuperAdminForm} setOperationStatus={setOperationStatus} />
            ) : (
                <ListSuperAdmin setShowAddSuperAdminForm={setShowAddSuperAdminForm} />
            )}
            {operationStatus.success && (
                <SuccessMessageComponent message={operationStatus.message} handleClose={handleCloseSuccessMessage} show={operationStatus.success} />
            )}
        </>
    );
}
